'use client'

import { usePathname } from 'next/navigation'
import { useMemo } from 'react'

import { ProductType } from '@/shared/types/deprecated-types'

import { useGetCartInfoQuery, useLazyGetCartInfoQuery } from '../api/cart-api-slice'
import { TCartItem } from '../types/cart-item'
import { getCartCount } from '../utils/getCartCount'
import { getCartServicesCount } from '../utils/getCartServicesCount'

const isAcsHaveRelatedProduct = (items: TCartItem[], relatedId: number) => items.some(item => item.ID === relatedId)

export const useCartData = () => {
	const pathname = usePathname()
	const isCartPage = pathname === '/cart' || pathname === '/cart/'

	const { data, isFetching, isLoading } = useGetCartInfoQuery(null, {
		skip: !isCartPage
	})
	const [refetch] = useLazyGetCartInfoQuery()

	const products = data?.PRODUCTS || []

	const visibleProducts = useMemo(() => {
		if (!products) return []
		return products.filter(
			({ TYPE_PRODUCTS, RELATED_PRODUCTS }) =>
				TYPE_PRODUCTS === ProductType.Product ||
				(TYPE_PRODUCTS === ProductType.Accessory && !isAcsHaveRelatedProduct(products, RELATED_PRODUCTS))
		)
	}, [products])

	const serviceCount = useMemo(() => (products ? getCartServicesCount(products) : 0), [products])

	const cartCount = useMemo(() => (data ? getCartCount(products, true) : 0), [data])

	const getBasketItem = (id: any) => (products ? products?.find(({ ID }) => ID === id) : null)

	return {
		products: products || [],
		price: isCartPage ? data?.PRICE : 0,
		basePrice: data?.OLD_PRICE || 0,
		visibleProducts,
		cartCount: cartCount,
		serviceCount,
		discountList: data?.DISCOUNT_LIST || [],
		bonusPay: data?.BONUS_PAY || 0,
		bonusFromOrder: data?.BONUS_ACCRUED || 0,
		showOrderButton: data?.SHOW_ORDER_BUTTON,
		isLoading: isFetching,
		isFetching,
		isInit: !isLoading,
		getBasketItem: getBasketItem,
		refetch: () => refetch(null, false)
	}
}
